export default __webpack_public_path__ + "static/media/whiteTruckRight.c7993c16.jpg";